export default class Faq {
    constructor() {
        this.faq = document.querySelectorAll('.faq-js');
        
        this.faq.forEach((el) => {
            const btnToggle = el.querySelector('.faq-toggle');
            btnToggle.addEventListener('click', this.toggleFaq.bind(this,el))
        })
    }

    toggleFaq(el,e) {
        const mask = el.querySelector('.faq-mask');
        el.classList.toggle('active');
        if (el.classList.contains('active')) {
          mask.style.transform = 'scaleY(0)';
        } else {
          mask.style.transform = 'scaleY(1)';
        }

    }

}
